export const SIGN_IN = '/signin';
export const HOME = '/';